<template>
  <custom-callout
    :has-toggle="true"
    class="mt-2"
    :border-color="getStatusColor(value.status)"
  >
    <ValidationObserver ref="documentBookOrder">
      <div class="row mt-2 pb-3">
        <div
          :class="[
            'col-md-2',
            { 'pt-3': !isMobile, 'col-8 pl-2 pt-2': isMobile },
          ]"
        >
          <custom-balloon
            class="px-3"
            :text="value.status"
            :background-color="getStatusColor(value.status)"
          />
        </div>
        <div class="col-md-10 pt-3">
          <div class="row mobile-row">
            <div class="col-md-4 col-sm-12 col-6">
              <div class="info-text-title">
                Título
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div class="col-md-3 col-6">
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div class="col-md-2 col-12">
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
            <div
              :class="[
                'col-md-2 col-sm-12 buttons-full',
                { 'ml-5 pl-4': !isMobile },
              ]"
            >
              <ActionButton
                class="mr-2 btn-transparent float-right"
                variant="outline-success"
                i="fas fa-save mx-auto"
                @click="document"
              />
              <ActionButton
                v-if="showRemoveButton"
                class="mr-2 btn-transparent float-right"
                variant="outline-danger"
                i="fas fa-times-circle mx-auto"
                @click="remove"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Medio de Lectura
                <br />
                (Braile, Letra Agrandada, Audio):
              </div>
              <div
                class="align-items-end d-flex p-0 pt-2 custom-radio-container"
              >
                <ValidationProvider rules="required">
                  <CustomRadio
                    ref="medio"
                    :name="`medio_${value.bookId}`"
                    :is-disabled="false"
                    :custom-error-msg="resources['180008']"
                    :change-event="onChangeMedio"
                    :options="optionsReadingMedium"
                    :is-question-list="true"
                    :error="!medioSelected"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="info-text-title">
                Pedido:
                <br />
                <br />
              </div>
              <div
                :class="{ 'pt-4': isMobile }"
                class="align-items-start d-flex p-0 pt-2 custom-radio-container"
              >
                <ValidationProvider rules="required">
                  <CustomRadio
                    :name="`pedido_${value.bookId}`"
                    :is-disabled="false"
                    :custom-error-msg="resources['180009']"
                    :change-event="onChangePedido"
                    :options="optionsYesNoList"
                    :is-question-list="true"
                    :error="!pedidoSelected"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="showRequestReason"
              :class="['col-md-5 col-sm-12 col-12', { 'pt-3': isMobile }]"
            >
              <div class="info-text-title">
                Razón:
              </div>
              <br v-show="!isMobile" />
              <div :class="['px-0 col-12 col-md-11 pt-2 pr-2']">
                <ValidationProvider rules="required">
                  <custom-drop-down
                    v-model="value.requestReason"
                    :name="`razon_${value.bookId}`"
                    fieldkey="id"
                    fieldname="value"
                    :clearable="false"
                    :options="requestReasonOptions"
                    placeholder="Seleccione"
                    :error="!reasonSelected"
                    :custom-error-msg="resources['180100']"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <div
      :class="[
        'row mt-2 buttons-mobile',
        { 'pt-2 mb-3': isMobile, 'pl-4': !isMobile },
      ]"
    >
      <div class="col" :class="{ 'pr-0': isMobile }">
        <ActionButton
          v-if="showRemoveButton"
          class="mr-2 btn-transparent lg-btn"
          variant="outline-danger"
          text="Remover"
          i="fas fa-times-circle mx-auto"
          @click="remove"
        />
      </div>
      <div class="col mr-2" :class="{ 'pl-1': isMobile }">
        <ActionButton
          class="mr-2 lg-btn"
          variant="success"
          text="Guardar"
          i="fas fa-save mx-auto"
          @click="document"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import store from '@/store/index';
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import { Colors } from '@/components/common';
import CustomRadio from 'custom-radio';
import { removeOrder, documentBookOrder } from '@/modules/books-requests/api';
import alert from 'utils/mixins/alert.mixin.js';
import readingMediumOptions from '@/utils/constants/book/readingMediumOptions';
import requestReasonOptions from '@/utils/constants/book/requestReasonOptions';
import CustomDropDown from 'custom-drop-down';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import resourcesService from '@/services/resources.js';
import { studentBookStatus } from '@/utils/constants/book/studentBookStatus';

export default {
  name: 'SelectedBookResultRow',
  components: {
    CustomCallout,
    CustomBalloon,
    ActionButton,
    CustomRadio,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      optionsYesNoList: null,
      filters: {
        selectedMedio: null,
        selectedPedido: null,
      },
      medioSelected: true,
      pedidoSelected: true,
      reasonSelected: true,
      optionsReadingMedium: null,
      resources: [],
    };
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    getStatusColor() {
      return (status) => {
        switch (status) {
          case 'Pendiente de Pedido':
            return Colors.YELLOW;
          case 'Pendiente de Compra':
            return Colors.YELLOW;
          case 'Pendiente de Entrega de Centro':
            return Colors.PINK;
          case 'Pendiente de Entrega de Escuela':
            return Colors.PINK;
          case 'Entregado':
            return Colors.GREEN;
          default:
            return Colors.YELLOW;
        }
      };
    },
    requestReasonOptions() {
      return requestReasonOptions;
    },
    showRemoveButton() {
      return this.value.statusId == studentBookStatus.PendientePedido;
    },
    showRequestReason() {
      return this.value.requested;
    },
  },
  created() {
    this.optionsReadingMedium = readingMediumOptions.map((a) => ({
      id: a.id,
      label: a.text,
      invalid: false,
      disabled: false,
      check: a.id == this.value.readingMediumCode,
    }));

    this.optionsYesNoList = [
      {
        id: true,
        name: 'question1',
        label: 'Si',
        check: this.value.requested,
        invalid: false,
        disabled: false,
      },
      {
        id: false,
        name: 'question2',
        label: 'No',
        check: this.value.readingMediumCode && !this.value.requested,
        invalid: false,
        disabled: false,
      },
    ];

    this.value.requestReason = this.requestReasonOptions.find(
      (x) => x.id == this.value.requestReasonCode
    );
  },
  methods: {
    async remove() {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el pedido del libro "${this.value.title}"?`,
        'Sí',
        'No'
      );

      if (!confirm) {
        return;
      }

      await removeOrder(this.value)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'El libro ha sido removido de mi lista de seleccionados exitosamente.',
              'success'
            );

            this.$parent.getStudentPendingBooksOrders();
            this.$parent.onSearch({ fromSelectedBooks: true });
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    onChangeMedio(item) {
      this.medioSelected = true;
      this.value.readingMediumCode = item.id;
    },
    onChangePedido(item) {
      this.pedidoSelected = true;
      this.value.requested = item.id;
    },
    async document() {
      let isValid =
        this.$refs.documentBookOrder.validate() && this.validateRadios();

      if (!isValid) {
        this.ShowToast('Error', 'Información Incompleta.', 'error');
        return;
      }

      this.value.requestReasonCode = this.value.requested
        ? this.value.requestReason?.id
        : null;
      await documentBookOrder(this.value)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'El pedido del libro ha sido documentado exitosamente.',
              'success'
            );
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    validateRadios() {
      this.medioSelected = this.optionsReadingMedium.some(
        (e) => e.check == true
      );
      this.pedidoSelected = this.optionsYesNoList.some((e) => e.check == true);
      this.reasonSelected =
        !this.value.requested ||
        (this.value.requested && this.value.requestReason);

      return this.medioSelected && this.pedidoSelected && this.reasonSelected;
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '180100',
        '180008',
        '180009',
      ]);
    },
    validateBeforeSubmit() {
      return this.$refs.documentBookOrder.validate() && this.validateRadios();
    },
  },
  async mounted() {
    await this.loadResources();
  },
};
</script>

<style scoped>
.mrc {
  margin-left: 30px;
}

.orange-icon {
  color: #ff7058;
}
.btn-transparent:not(:hover) {
  background: transparent !important;
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
  background-color: #e2e2e2 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.buttons-mobile {
  display: none;
}

@media only screen and (max-width: 375px) {
  .selct-text {
    display: none;
  }

  .fa-check {
    margin-right: 0px !important;
  }

  .buttons-mobile {
    display: flex;
  }

  .lg-btn {
    width: 100%;
  }

  .buttons-full {
    display: none;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 12px !important;
  }

  ::v-deep .balloon-container {
    font-size: 12px !important;
  }
}

::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

::v-deep .bg-gray {
  background-color: #e2e2e2 !important;
}

::v-deep .bg-green {
  background-color: #2db782 !important;
  border-color: #2db782;
}

::v-deep .radio .cr {
  border: 2px solid #ffffff !important;
}

::v-deep .step-label {
  color: #ffffff !important;
}

::v-deep .step-label-mobile {
  color: #ffffff !important;
}

::v-deep .balloon-container {
  font-size: 16px;
}
</style>
